<script lang="ts">
    export let text: string = 'Not found anything';
    export let opacity: number = 0.5;
</script>


<div class="text" style="opacity: {opacity}">{text}</div>


<style>
    .text {
        /*font-size: 14px;*/
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
</style>